module.exports = __webpack_public_path__ + "img/awei.b9ed7bd4.png";